module.exports = __webpack_public_path__ + "img/login-main-img.9d52d7db.png";